import { render, staticRenderFns } from "./DeleteNBCommandView.vue?vue&type=template&id=47eec096&"
import script from "./DeleteNBCommandView.vue?vue&type=script&lang=js&"
export * from "./DeleteNBCommandView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports